import { useEffect, useState } from 'react'

import { Input } from '@skytech/ui'
import { Container } from '@skytech/ui/Container'
import { useDebounce } from '@skytech/utils'
import { useNavigate } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import Tabs from '@/components/Tabs'
import { useSearchParamsByKey } from '@/hooks/searchParams'

import { DEVICE_ORDER_STATUS_ID, STATUS_FILTER_OPTIONS } from './constants'
import DeviceApplicationList from './DeviceApplicationList'

import './index.styles.scss'

const DeviceApplicationListPage = () => {
  const navigate = useNavigate()
  const translate = useTranslation()

  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status')
  const [querySearch, setQuerySearch] = useSearchParamsByKey('search')

  const [searchFilter, setSearchFilter] = useState(querySearch || '')
  const [statusFilter, setStatusFilter] = useState(
    Number(queryStatus) || DEVICE_ORDER_STATUS_ID.NEW
  )

  const debouncedSearchTerm = useDebounce(searchFilter, 500)

  useEffect(() => {
    setSearchFilter(querySearch || '')
    setStatusFilter(Number(queryStatus) || DEVICE_ORDER_STATUS_ID.NEW)
  }, [querySearch, queryStatus])

  useEffect(() => {
    setQuerySearch(debouncedSearchTerm)
  }, [debouncedSearchTerm, setQuerySearch])

  return (
    <Container onSwipedLeft={() => navigate('/')} className="device-application-list">
      <Container.Header>
        <Translation id="Device Orders" />
      </Container.Header>

      <div className="device-application-list__options">
        <div className="device-application-list__options__option">
          <Tabs
            tabs={STATUS_FILTER_OPTIONS}
            selectedValue={statusFilter}
            onClick={statusId => {
              setStatusFilter(Number(statusId))
              setQueryStatus(statusId)
            }}
          />
        </div>

        <div className="device-application-list__options__option">
          <Input
            id="device-search-filter"
            type="text"
            value={searchFilter}
            placeholder={translate('Search')}
            onChange={e => setSearchFilter(e.target.value)}
          />
        </div>
      </div>

      <DeviceApplicationList searchFilter={searchFilter} statusFilter={statusFilter} />
    </Container>
  )
}

export default DeviceApplicationListPage
